module.exports = __webpack_public_path__ + "img/116.8.ac64f952.png";